import axios from "axios";
import { baseUrl } from "../constants";
//import { setBearerAuthorizationHeader } from "../../utils/interceptors";

const GetDevices = () => {
  return axios
    .get(`${baseUrl()}/Device/GetDevices`)
    .then((data) => {
      return data;
    })
      .catch((error) => {
          if (error.response.status === 307) {
              // Handle the specific status code 307 - Status307TemporaryRedirect
              const errResponse = error.response.data;
              let newToken = errResponse.token;

              const _auth = JSON.parse(sessionStorage.getItem("auth"));
              _auth.token = newToken;
              sessionStorage.setItem("auth", JSON.stringify(_auth));

              return axios
                  .get(`${baseUrl()}/Device/GetDevices`)
                  .then((data) => {
                      return data;
                  })
                  .catch((error) => {
                      console.error("DeviceServices: Get Devices API", error);
                  });
          } else {
              console.error("DeviceServices: Get Devices API", error);
          }
    });
};

const GetDevicesByVesselId = (vesselid) => {
    return axios
        .get(`${baseUrl()}/Device/GetDevices/${vesselid}`)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .get(`${baseUrl()}/Device/GetDevices/${vesselid}`)
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("DeviceServices: Get Devices by VesselId API", error);
                    });
            } else {
                console.error("DeviceServices: Get Devices by VesselId API", error);
            }
        });
};

const SetDeviceStatus = (deviceid, status) => {
  return axios
      .post(`${baseUrl()}/Device/SetDeviceStatus`, {
          deviceid,
          status
      })
      .then((data) => {
          return data;
      })
      .catch((error) => {
          if (error.response.status === 307) {
              // Handle the specific status code 307 - Status307TemporaryRedirect
              const errResponse = error.response.data;
              let newToken = errResponse.token;

              const _auth = JSON.parse(sessionStorage.getItem("auth"));
              _auth.token = newToken;
              sessionStorage.setItem("auth", JSON.stringify(_auth));

              return axios
                  .post(`${baseUrl()}/Device/SetDeviceStatus`, {
                    deviceid,
                      status
                  })
                  .then((data) => {
                      return data;
                  })
                  .catch((error) => {
                      console.error("DeviceServices: Set Device Status API", error);
                  });
          } else {
              console.error("DeviceServices: Set Device Status API", error);
          }
      });
};

const AddDevice = (device) => {
  return axios
      .post(`${baseUrl()}/Device/AddDevice`, {
          devicename : device.devicename,
          deviceurl : device.deviceurl,
          vesselid: device.vesselid,
      })
      .then((data) => {
          return data;
      })
      .catch((error) => {
          if (error.response.status === 307) {
              // Handle the specific status code 307 - Status307TemporaryRedirect
              const errResponse = error.response.data;
              let newToken = errResponse.token;

              const _auth = JSON.parse(sessionStorage.getItem("auth"));
              _auth.token = newToken;
              sessionStorage.setItem("auth", JSON.stringify(_auth));

              return axios
                .post(`${baseUrl()}/Device/AddDevice`, {
                  devicename : device.devicename,
                  deviceurl : device.deviceurl,
                  vesselid: device.vesselid,
                  })
                  .then((data) => {
                      return data;
                  })
                  .catch((error) => {
                      console.error("DeviceServices: Add Device API", error);
                  });
          } else {
              console.error("DeviceServices: Add Device API", error);
          }
      });
};

const UpdateDevice = (device, isVesselChanged) => {
  return axios
      .post(`${baseUrl()}/Device/UpdateDevice`, {
          deviceid: device.deviceid,
          devicename : device.devicename,
          deviceurl : device.deviceurl,
          vesselid: device.vesselid,
          isvesselchanged: isVesselChanged,
      })
      .then((data) => {
          return data;
      })
      .catch((error) => {
          if (error.response.status === 307) {
              // Handle the specific status code 307 - Status307TemporaryRedirect
              const errResponse = error.response.data;
              let newToken = errResponse.token;

              const _auth = JSON.parse(sessionStorage.getItem("auth"));
              _auth.token = newToken;
              sessionStorage.setItem("auth", JSON.stringify(_auth));

              return axios
                .post(`${baseUrl()}/Device/UpdateDevice`, {
                  deviceid: device.deviceid,
                  devicename : device.devicename,
                  deviceurl : device.deviceurl,
                  vesselid: device.vesselid,
                  isvesselchanged: isVesselChanged,
                  })
                  .then((data) => {
                      return data;
                  })
                  .catch((error) => {
                      console.error("DeviceServices: Update Device API", error);
                  });
          } else {
              console.error("DeviceServices: Update Device API", error);
          }
      });
};

const DeleteDevice = (deviceid) => {
  return axios
      .post(`${baseUrl()}/Device/DeleteDevice`, {
          deviceid,
      })
      .then((data) => {
          return data;
      })
      .catch((error) => {
          if (error.response.status === 307) {
              // Handle the specific status code 307 - Status307TemporaryRedirect
              const errResponse = error.response.data;
              let newToken = errResponse.token;

              const _auth = JSON.parse(sessionStorage.getItem("auth"));
              _auth.token = newToken;
              sessionStorage.setItem("auth", JSON.stringify(_auth));

              return axios
                  .post(`${baseUrl()}/Device/DeleteDevice`, {
                      deviceid
                  })
                  .then((data) => {
                      return data;
                  })
                  .catch((error) => {
                      console.error("DeviceServices: Delete Device API", error);
                  });
          } else {
              console.error("DeviceServices: Delete Device API", error);
          }
      });
};



const DeviceServices = { GetDevices, GetDevicesByVesselId, SetDeviceStatus, AddDevice, UpdateDevice, DeleteDevice };

export default DeviceServices;
